module.exports = __webpack_public_path__ + "static/3dphone-52c931ddb348d8cd8cc5a375e6c72d3c.svg";